export const bulkArchive = tbd => ({
  method: 'POST',
  url: '/contracts/bulk/archive',
  data: {
    tbd
  }
});

export const bulkMoveToFolder = ({ ids, childOf }) => ({
  method: 'POST',
  url: '/contracts/bulk/move-to-folder',
  data: {
    ids,
    childOf
  }
});

export const bulkCreate = (data) => ({
  method: 'POST',
  url: '/contracts/bulk/create',
  data
});

export const bulkSign = ids => ({
  method: 'POST',
  url: '/contracts/sign/all',
  data: {
    ids
  }
});
export const bulkResend = ids => ({
  method: 'POST',
  url: '/contracts/bulk/resend',
  data: {
    ids
  }
});
export const bulkCancel = ({ids, cancelReason}) => ({
  method: 'POST',
  url: '/contracts/bulk/cancel',
  data: {
    ids,
    cancelReason
  }
});

export const bulkFinalize = ({ids}) => ({
  method: 'POST',
  url: '/contracts/bulk/finalize',
  data: {
    ids
  }
});
export const bulkExport = (url) => ({
  method: 'GET',
  url,
  data: { 'export': 1 }
})
export const fetchContractList = ({
  templateId,
  references,
  pendingByMe,
  parentReferenceId,
  searchMetadataId,
  page = 1,
  perPage,
  recordId,
  search,
  filterown = false,
  filter = '',
  limit,
  url,
  sortBy,
  sortDirection
}) => {
  let queryString = `page=${page}&search=${search}&filter=${filter}&limit=${limit}&filterown=${filterown}`;

  if (recordId) {
    queryString += `&record=${recordId}`;
  }

  if (references) {
    queryString = `references=${references}`;
  }

  if (parentReferenceId) {
    queryString = `parentReferenceId=${parentReferenceId}`;
  }

  if (sortBy) {
    queryString += `&sortBy=${sortBy}&sortDirection=${sortDirection}`;
  }

  if (searchMetadataId) {
    queryString += `&searchMetadataId=${searchMetadataId}`;
  }
  if (pendingByMe !== undefined) {
    queryString += `&pendingByMe=${pendingByMe}`;
  }

  return {
    method: 'GET',
    url: `${url}?${queryString}`
  };
};
export const contractAction = (contractId, action, data, isTemplate) => {
  return ({
    method: 'POST',
    url: `/${isTemplate ? 'templates' : 'ncontracts'}/${contractId}/${action}`,
    data
  });
}

export const clientContractAction = (contractId, action, data) => {
  return ({
    method: 'POST',
    url: `/client/contracts/${contractId}/${action}`,
    data
  })
}

export const clientParticipantAction = (contractId, action, participantId, data) => {
  return ({
    method: 'POST',
    url: `/client/contracts/${contractId}/${action}/participant/${participantId}`,
    data
  })
}

export const convertToTemplate = ({
  contractId
}) => ({
  method: 'POST',
  url: `/templates/${contractId}`
});
export const fetchContract = contractId => ({
  method: 'GET',
  url: `/contracts/${contractId}`
});
export const fetchIncomingContractList = ({
  page,
  perPage,
  search
}) => ({
  method: 'GET',
  endpoint: `/incoming-contracts?page=${page}&perPage=${perPage}&search=${search}`
});
export const saveContract = data => ({
  method: 'PUT',
  url: `/contracts/${data._id}`,
  data
});

export const updateContract = ({
  contractId,
  ...rest
}) => ({
  method: 'PUT',
  url: `/contracts/${contractId}`,
  data: rest
});

export const createContract = values => {
  return {
    method: 'POST',
    url: '/contracts',
    data: values
  };
};
export const getMassiveStatus = ({
  method: 'GET',
  url: '/contracts/sign/all',
})

export const sendContract = values => ({
  method: 'POST',
  endpoint: `/contract/send/${values._id}`,
  body: values
});
export const resendContract = values => ({
  method: 'POST',
  endpoint: `/notifications/email/${values.contractId}/${values.participantId}/participants`
});
export const getTimeline = (contractId, types) => ({
  method: 'GET',
  url: `/contracts/timeline/${contractId}${types ? `?types=${types}` : ''}`
});
export const linkContract = ({
  parentId,
  childId,
  copyPartInfo = false,
  copyMilestones = false
}) => ({
  method: 'POST',
  url: `/ncontracts/${parentId}/link`,
  data: {
    parentId,
    childId,
    copyPartInfo,
    copyMilestones
  }
});
export const duplicateContract = ({
  contractId,
  ...values
}) => ({
  method: 'POST',
  url: `/ncontracts/${contractId}/duplicate`,
  data: values
});
export const getParsedContractTypes = () => ({
  method: 'GET',
  url: '/contract-types/parsed'
});
export const getContractTypes = () => ({
  method: 'GET',
  url: '/contract-types'
});
export const getContractTypeById = (contractTypeId) => ({
  method: 'GET',
  url: `/contract-types/${contractTypeId}`
});
export const addMassive = data => ({
  method: 'POST',
  url: '/contracts/massive',
  data
});
export const fetchProperty = (contractId, property, params, isTemplate) => ({
  method: 'GET',
  url: `/${isTemplate ? 'templates' : 'ncontracts'}/${contractId}/${property}`,
  params
})
export const getCID = (data) => ({
  method: 'POST',
  url: '/api/ipfs/compare',
  data
});
export const getPackage = ({ contractId }) => ({
  url: `/contracts/package/${contractId}`,
  method: 'GET',
  responseType: 'blob'
});

export const uploadVideoAcceptance = (data) => ({
  method: 'POST',
  url: '/video/acceptance',
  data
});

export const sendShield3Video = ({ contractId, participantId, ...data }) => ({
  method: 'POST',
  url: `/client/contracts/${contractId}/consent`,
  data
})
export const resendSpectatorEmail = ({ documentId, spectatorId, ...values }) => ({
  method: 'POST',
  url: `/notifications/email/${documentId}/${spectatorId}/spectators`,
  data: values,
});

export const resendParticipantEmail = ({ documentId, participantId, ...values }) => ({
  method: 'POST',
  url: `/notifications/email/${documentId}/${participantId}/participants`,
  data: values,
});

export const exportContractPackage = (documentId) => ({
  method: 'GET',
  url: `/contracts/export/single/${documentId}`,
  responseType: 'blob'
});

export const sendNotification = ({ documentId, notificationId }) => ({
  method: 'PUT',
  url: `/notifications/${documentId}/send/${notificationId}`,
})

export const getAuditTrail = (contractId) => ({
  method: 'GET',
  url: `/contracts/audit/${contractId}`,
})

export const fetchClientContract = (contractId, password, fingerprintId) => ({
  method: 'GET',
  params: { password },
  url: `/client/contracts/v2/${contractId}?fingerprintId=${fingerprintId}`,
})

export const getExternal = (contractId, document) => ({
  method: 'GET',
  url: `/contracts/external/${document}/${contractId}`
})

export const getConversations = (contractId) => ({
  method: 'GET',
  url: `/contracts/${contractId}/conversations`
})

export const postConversation = (data) => ({
  method: 'POST',
  url: `/contracts/${data.contractId}/conversations`,
  data
})

export const getPrivate = (data) => ({
  method: 'GET',
  url: `/contracts/${data.contractId}/conversations/privates/${data.email}`
})

export const createGroupConversation = (contractId, data) => ({
  method: 'POST',
  url: `/contracts/${contractId}/conversations`,
  data
})

export const compareElements = ({ contractId, ...data }) => ({
  method: 'POST',
  url: `/admin/contract/history/compare/${contractId}`,
  data
})